










import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class AppRefresh extends Vue {
  @Prop({ type: Function }) readonly refreshHandler!: Function

  handleRefresh () {
    if (this.refreshHandler) {
      this.refreshHandler()
    }
  }
}
